import React from 'react'
import { useAuthStore } from '../../store/authStore'
import { getUserType } from '../../utils/userPermissions'
import GovRfqsPage from '../../pages/enterprise/gov-rfqs'
import MyRfqsPage from '../../pages/gov/MyRfqsPage'

const RfqRouter: React.FC = () => {
  const { user } = useAuthStore()
  const userType = getUserType(user)

  console.log('RfqRouter - User:', user?.email, 'UserType:', userType)

  // For agencies, show "My RFQs" page
  if (userType === 'AGENCY') {
    console.log('RfqRouter - Rendering MyRfqsPage for agency')
    return <MyRfqsPage />
  }

  // For vendors, show available RFQs page
  if (userType === 'ENTERPRISE_VENDOR') {
    console.log('RfqRouter - Rendering GovRfqsPage for vendor')
    return <GovRfqsPage />
  }

  // Fallback for other user types
  console.log('RfqRouter - Rendering GovRfqsPage as fallback')
  return <GovRfqsPage />
}

export default RfqRouter